import React, { useContext, useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import toast from "react-hot-toast";
import moment from "moment";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { formatDate, numberWithCommas, getRelevantLease } from "../../Utility";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import CalenderIcon from "../../assets/images/calendar-icon.svg";
import { MyDropzone } from "./components/Dropzone";
import { SpinnerLoading } from "../../components/Loadings";
import PropertyManager from "./components/PropertyManager";
import Address from "./components/Address";
import DocumentList from "./components/DocumentList";
import LeaseSummary from "./components/LeaseSummary";
import PaymentDues from "./components/PaymentDues";
import { createPlaidLink } from "../../graphql/mutations";
import envFile from "../../envFile";
import {
  getTransactions,
  fetchAllBankAccounts,
  fetchTpLeaseBankAccounts,
  fetchDashboardData,
  fetchSignedUrl,
  getRdsFN,
  updateRecordTB,
  fetchFuturePayments,
  listTenantCategoryFN,
} from "../../Utility/ApiService";
import { Context } from "../../Utility/ContextManager";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import PDFModal from "./components/modals/PDFModal";

const validationSchema = yup
  .object({
    scheduledPayments: yup.array().of(
      yup.object().shape({
        category: yup.string().typeError("Please enter a valid Insurance Carrier").nullable(),
        next_occurance: yup.string().typeError("Please select a valid Renewal Date").nullable(),
        // annual_premium: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
        payment_amount: yup.string().typeError("Please enter valid amount").nullable(),
      })
    ),
  })
  .required();

const Dashboard = () => {
  const {
    user,
    setPropertyUnitDocuments,
    setBankAccounts,
    allTransactions,
    setAllTransactions,
    setPlaidToken,
    setPropertyManagerInfo,
    propertyManagerInfo,
  } = useContext(Context);
  // const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const location = useLocation();

  const [propertyDetails, setPropertyDetails] = useState([]);
  const [propertyDetail, setPropertyDetail] = useState(null);
  const [propertyPhotos, setPropertyPhotos] = useState([]);
  const [scheduledPaymentsModalShow, setScheduledPaymentsModalShow] = useState(false);
  const [upcomingPayments, setUpcomingPayments] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [tenantCategories, setTenantCategories] = useState([]);
  const [paymentsDue, setPaymentsDue] = useState([]);
  const [leases, setLeases] = useState([]);
  const [expiredLeasesCount, setExpiredLeasesCount] = useState([]);
  const [unfilteredLeases, setUnfilteredLeases] = useState([]);
  const [tpLeaseBankAccounts, setTpLeaseBankAccounts] = useState([]);
  const [tenantLedger, setTenantLedger] = useState([]);
  const [isMember, setIsMember] = useState(false);
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [currentPDFUrl, setCurrentPDFUrl] = useState("");
  const [currentMemberStatement, setCurrentMemberStatement] = useState(null);
  const [payabliLoading, setPayabliLoading] = useState(false);
  const [tenantWidgets, setTenantWidgets] = useState([]);

  const { memberStatementId = null } = state || {};
  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    control,
    watch,
    setValue,
    // formState: { errors },
  } = methods;

  const { fields: ScheduledPaymentsFieldArr, append: ScheduledPaymentsAppend } = useFieldArray({
    control,
    name: "scheduledPayments",
  });

  useEffect(() => {
    getBanksTransaction();
    getDashBoardData();
    getAllBankAccounts();
    getPlaidtoken();
    getFuturePayments();
    fetchAllTenantPayments();
    fetchAllTenantLeases();
    fetchAllTpLeaseBankAccounts();
    listTenantCategoryFN().then((data) => {
      setTenantCategories(data);
    });
    fetchTenantWidgets();
  }, []);

  useEffect(() => {
    if (propertyDetail) {
      const memberStatus =
        propertyDetail?.property_type === "Space" || propertyDetail?.property_type === "Co-Op" ? true : false;
      setIsMember(memberStatus);
    }
  }, [propertyDetail]);

  useEffect(() => {
    if (propertyManagerInfo) fetchAllPropertyUnitDocs();
  }, [propertyManagerInfo]);

  useEffect(() => {
    if (upcomingPayments?.length > 0 && Object.keys(upcomingPayments)?.length > 0) {
      const payments = upcomingPayments?.map((payment) => ({
        payment_amount: payment?.payment_amount,
        category: payment?.category,
        next_occurance: payment?.next_occurance,
        status: payment?.status,
        id: payment?.id,
        bank_account_id: payment?.bank_account_id,
        member_auto_payment: payment?.member_auto_payment,
      }));
      setValue("scheduledPayments", payments);
    }
  }, [upcomingPayments]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const resultTextParam = searchParams.get("resultText");
    if (resultTextParam) {
      const resultString = resultTextParam?.trim();
      if (resultString === "Approved") {
        toast.success("Your Payabli payment was successful! Your payment should appear shortly");
      } else {
        toast.success("You initiated a Payabli payment! Please check back later to keep track of your payment status");
      }

      // Set loading to true and wait 8 seconds before running getTenantLedger
      setPayabliLoading(true);
      setTimeout(() => {
        const reloadPage = async () => {
          try {
            setPayabliLoading(false);
            window.location.href = "/Dashboard";
            /*const newUrl = `${location.pathname}`;
              navigate(newUrl, { replace: true });
              */
          } catch (error) {
            setLoading(false);
            console.error("Error fetching tenant ledger:", error);
            setPayabliLoading(false);
          }
        };
        reloadPage(); // Call the async function
      }, 9000); // 8000 milliseconds = 8 seconds
    }
  }, []);

  // Assuming `response` is an array of leases
  /*
  const getRelevantLease = (leases) => {
    const currentDate = moment();
    let activeLease = null;
    let nextLease = null;
    let lastLease = null;
    let expiredLeasesCount = 0; // Initialize a counter for expired leases

    leases.forEach((lease) => {
      const leaseStartD = formatDate(lease.lease_start);
      const leaseEndD = formatDate(lease.lease_end);
      const leaseStartDate = moment(leaseStartD);
      const leaseEndDate = moment(leaseEndD);

      // Check for active lease
      if (leaseStartDate <= currentDate && leaseEndDate >= currentDate) {
        activeLease = lease;
      } else if (leaseEndDate < currentDate) {
        // Count expired leases, but not beyond the specified limit
        if (expiredLeasesCount < 5) {
          expiredLeasesCount += 1;
        }
      }

      // Find the next closest future lease
      if (leaseStartDate > currentDate && (!nextLease || leaseStartDate < moment(nextLease.lease_start))) {
        nextLease = lease;
      }

      // Find the most recent past lease
      if (leaseEndDate < currentDate && (!lastLease || leaseEndDate > moment(lastLease.lease_end))) {
        lastLease = lease;
      }
    });

    // Update the expired leases count using the state updater function outside the forEach loop
    // setExpiredLeasesCount(expiredLeasesCount); // Uncomment and use if you are managing state outside this function

    // Determine which lease to return based on the conditions, after the forEach loop
    const relevantLease = activeLease || nextLease || lastLease;
    return relevantLease ? [relevantLease] : []; // Return in array format
  };
*/
  /*
  useEffect(() => {
    if (isMember) {
      const filteredPropertyDetails = propertyDetails?.filter(
        //(lease) => checkIfExpired(lease) === false && checkIfWithin(lease) && lease?.active === 1
        (lease) => checkIfWithin(lease) && lease?.active === 1
      );
      setPropertyDetails(filteredPropertyDetails);
      if (filteredPropertyDetails?.length > 0) {
        setPropertyDetail(filteredPropertyDetails[0]);
      }
    } else {
      if (propertyDetails?.length > 0) {
        setPropertyDetail(propertyDetails[0]);
      }
    }
  }, [isMember]);
*/
  const fetchAllPropertyUnitDocs = async () => {
    try {
      setLoading(true);
      const propertiesData = await getRdsFN("tenantAndPmDocs", {
        tpId: user?.id,
        uId: propertyManagerInfo?.id,
      });
      const allProperties = await Promise.all(propertiesData.map((property) => fetchPropertiesDoc(property)));
      //const filteredProperties = allProperties.filter((i) => i?.property_unit_id === propertyDetail?.property_unit_id);
      // Open preview for the first document in the list
      const memberStatement = memberStatementId
        ? allProperties?.find((i) => i?.id === Number(memberStatementId))
        : null;
      if (memberStatementId && !memberStatement) {
        toast.error("Member Statement not found");
      }

      if (memberStatement) {
        //window.open(memberStatement?.path, "_blank");
        setCurrentMemberStatement(memberStatement);
        handleOpenPDF(memberStatement?.path);
        /*fetch(memberStatement?.path).then((response) =>
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "MemberMonthlyStatement-344688935.pdf");
            document.body.appendChild(link);
            link.click();
          })
        );
        */
      }
      setPropertyUnitDocuments(allProperties);
      setLoading(false);
    } catch (error) {
      console.log("fetchAllPropertyUnitDocs ", error);
      setLoading(false);
    }
  };

  const fetchAllTpLeaseBankAccounts = async () => {
    try {
      setLoading(true);
      const response = await getRdsFN("tpLeaseBankAccounts", {
        tenantId: user?.id,
      });
      if (response?.length > 0) {
        setTpLeaseBankAccounts(response[0]);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const fetchAllTenantPayments = async () => {
    try {
      setLoading(true);
      const response = await getRdsFN("tpLeasePayments", {
        tenantId: user?.id,
      });
      if (response?.length > 0) {
        setPaymentsDue(response);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const fetchTenantWidgets = async () => {
    try {
      const response = await getRdsFN("tpWidgets", {
        tenantId: user?.id,
      });
      console.log(response);
      if (response?.length > 0) {
        console.log(response);
        setTenantWidgets(response);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchAllTenantLeases = async () => {
    try {
      setLoading(true);
      const response = await getRdsFN("tpLeases", {
        tenantId: user?.id,
      });
      if (response?.length > 0) {
        const currentDate = moment();
        const filteredLeases = response?.filter((lease) => {
          const isWithin = checkIfWithin(lease);
          const leaseEndDate = moment(lease.lease_end); // Parse lease_end date
          return isWithin; // Compare lease_end with today
        });
        const sortedLeases = filteredLeases?.slice().sort((a, b) => {
          const leaseEndA = new Date(a.lease_end);
          const leaseEndB = new Date(b.lease_end);

          // Compare the lease_end dates in descending order
          return leaseEndB - leaseEndA;
        });
        setLeases(sortedLeases);
        setUnfilteredLeases(response);
        const relevantLease = getRelevantLease(response);
      }
      getTenantLedger(user?.id);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const getTenantLedger = async (tenantId) => {
    try {
      setLoading(true);
      let response = await getRdsFN("tpLedger", { tenantId: tenantId });
      const renamedTenantLedger = response?.map((item) => {
        return {
          ...item,
          category: item?.category === "Special Assessment" ? "Rent" : item?.category,
        };
      });
      setTenantLedger(renamedTenantLedger);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const handleOpenPDF = (pdfUrl) => {
    setCurrentPDFUrl(pdfUrl);
    setShowPDFModal(true);
  };

  const handleClosePDF = () => {
    setShowPDFModal(false);
  };
  const getDashBoardData = async () => {
    try {
      setLoading(true);
      const data = await fetchDashboardData(user?.id);
      const tpLeaseBankAccounts = await fetchTpLeaseBankAccounts({ tenant_id: user?.id });
      let tpLeaseBankAccountsAndPropertyDetails = [];
      if (tpLeaseBankAccounts?.length > 0) {
        tpLeaseBankAccountsAndPropertyDetails = tpLeaseBankAccounts?.map((bankAccountObj) => ({
          ...bankAccountObj,
          ...data,
        }));
      }
      if (data) {
        setPropertyDetails(tpLeaseBankAccountsAndPropertyDetails);
        setPropertyDetail(tpLeaseBankAccountsAndPropertyDetails[0]);
        getPropertyPhotos(data);
        fetchPropertyManager(data);
      } else {
        toast.error("Not found any data from DB");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error-----", error);
      toast.error(error.message || "Something went wrong please try again later");
    }
  };

  const fetchPropertyManager = async (data) => {
    try {
      setLoading(true);
      // const res = await API.graphql(graphqlOperation(getLambdaResolver, { table: "User", id: user?.created_by }));
      const res = await getRdsFN("tbSelect", {
        source: "usr",
        id: user?.created_by,
      });

      const propertyManagerInfo = res[0];
      if (data?.pm_first_name && data?.pm_first_name !== "") propertyManagerInfo.first_name = data?.pm_first_name;
      if (data?.pm_last_name && data?.pm_last_name !== "") propertyManagerInfo.last_name = data?.pm_last_name;
      if (data?.pm_phone && data?.pm_phone !== "") propertyManagerInfo.phone = data?.pm_phone;
      if (data?.pm_email && data?.pm_email !== "") propertyManagerInfo.email = data?.pm_email;
      setPropertyManagerInfo(propertyManagerInfo);
      setLoading(false);
    } catch (error) {
      console.log("error fetchPropertyManager ", error);
      setLoading(false);
    }
  };

  const getBanksTransaction = async () => {
    try {
      setLoading(true);
      const tenantId = user?.id;
      const response = await getTransactions({
        tenantId,
        startDate: moment().subtract(30, "days"),
        endDate: moment(),
      });
      if (response) {
        setAllTransactions(response);
      }
      setLoading(false);
    } catch (err) {
      console.log("List bankMaskedNumber Error", err);
      setLoading(false);
    }
  };

  const getPropertyPhotos = async (data) => {
    try {
      setLoading(true);
      fetchPropertiesWithPhotos(data).then((images) => {
        setPropertyPhotos(images);
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error.message || "Something went wrong please try again later");
    }
  };

  const fetchPropertiesDoc = (unitDoc) => {
    if (unitDoc?.document_url !== null || unitDoc?.document_name !== null) {
      return new Promise((resolve) => {
        fetchSignedUrl(unitDoc?.document_url ? unitDoc?.document_url : unitDoc.document_name, "property").then(
          (res) => {
            var newProperty = Object.assign({}, unitDoc);
            newProperty.path = res;
            resolve(newProperty);
          }
        );
      });
    } else {
      return new Promise((resolve) => {
        var newProperty = Object.assign({}, unitDoc);
        let res = "https://foliolens160827-dev.s3.amazonaws.com/public/property/house.jpeg";
        newProperty.path = res;
        resolve(newProperty);
      });
    }
  };

  const fetchPropertiesWithPhotos = async (prop) => {
    return new Promise((resolve, reject) => {
      let allProperties = [];
      if (prop.cover_photo) {
        if (prop.cover_photo.split(",").length > 1) {
          allProperties = prop.cover_photo.split(",").map((image) => {
            return fetchPropertiesWithPhoto(image.split("/")[1]);
          });
        } else {
          allProperties.push(fetchPropertiesWithPhoto(prop?.cover_photo.split("/")[1]));
        }
      }

      Promise.all(allProperties)
        .then((allProperties) => {
          resolve(allProperties);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const fetchPropertiesWithPhoto = (image) => {
    return new Promise((resolve) => {
      fetchSignedUrl(image, "property").then((res) => {
        resolve(res);
      });
    });
  };

  const getFuturePayments = async () => {
    try {
      const res = await fetchFuturePayments({ tenant_id: user?.id });
      setUpcomingPayments(res.slice(0, 50));
      return res;
    } catch (error) {
      console.log(error);
    }
  };
  const getAllBankAccounts = async () => {
    try {
      setLoading(true);
      const data = await fetchAllBankAccounts({ tenant_id: user?.id });
      if (data) {
        setBankAccounts(data);
      }
      setLoading(false);
    } catch (error) {
      console.log("error fetchAllMaintenances ", error);
      setLoading(false);
    }
  };

  const deleteDocument = async (docID) => {
    try {
      setLoading(true);
      await updateRecordTB("PropertyUnitDocument", {
        active: 0,
        id: docID,
      });

      fetchAllPropertyUnitDocs(user);
      setLoading(false);
    } catch (error) {
      console.log("error deleteDocument error ", error);
      setLoading(false);
    }
  };

  const getPlaidtoken = async () => {
    setLoading(true);
    let obj = {
      userId: user?.cognito_user_id,
      userName: envFile.PLAID_USERNAME,
    };

    await API.graphql(graphqlOperation(createPlaidLink, obj))
      .then((res) => {
        setPlaidToken(res.data.createPlaidLink.response);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleViewScheduledPayments = async (isEditing = false) => {
    try {
      setLoading(true);
      const formattedTransactions = allTransactions
        ?.filter((transaction) => transaction?.status === "PENDING")
        .map((item) => {
          const category = tenantCategories?.find((cat) => cat?.id === item?.category_id)?.category;
          return {
            id: item?.id,
            payment_amount: item?.transaction_amount,
            next_occurance: item?.date,
            category: category,
            amount: item?.payment_amount,
            bank_account_id: item?.bank_account_id,
            status: "PENDING",
          };
        });
      const futurePaymentsRes = await fetchFuturePayments({ tenant_id: user?.id });
      const res = [...futurePaymentsRes, ...formattedTransactions];
      const slicedResults = res.slice(0, 50);
      const todayDate = new Date();
      // Get the year, month, and day components
      const year = todayDate?.getFullYear();
      const month = String(todayDate?.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(todayDate?.getDate()).padStart(2, "0");
      // Format the components into "YYYY-MM-DD" format
      const formattedDate = `${year}-${month}-${day}`;
      const filteredData = slicedResults?.filter(
        (item) =>
          moment(item.next_occurance, "YYYY-MM-DD")?.isSameOrAfter(formattedDate, "day") || item?.status === "PENDING"
      );

      //const filteredResults = slicedResults.filter((item) => item?.category !== "Security Deposit");
      setUpcomingPayments(filteredData);
      setScheduledPaymentsModalShow(true);
      if (isEditing) {
        setEditMode(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const conditionalParse = (input) => {
    if (typeof input === "string") {
      return parseFloat(input.replace("$", "").replace(",", ""));
    } else {
      return input;
    }
  };
  const checkIfWithin = (lease) => {
    //check if today is within the lease period
    const currentDate = moment().format("YYYY-MM-DD");
    const leaseStartDate = moment.utc(lease?.lease_start).format("YYYY-MM-DD");
    const leaseEndDate = moment.utc(lease?.lease_end).format("YYYY-MM-DD");
    if (leaseStartDate <= currentDate && leaseEndDate >= currentDate) {
      return true;
    }
    if (expiredLeasesCount < 5) {
      setExpiredLeasesCount(expiredLeasesCount + 1);
      return true;
    }
    return false;
  };

  const handleEditScheduledPayments = async () => {
    try {
      if (upcomingPayments?.length === 0) {
        setScheduledPaymentsModalShow(false);
        return;
      }
      setLoading(true);
      const preFilteredScheduledPayments = watch("scheduledPayments");
      const scheduledPayments = preFilteredScheduledPayments?.filter((item) => item?.status !== "PENDING");
      const promises = scheduledPayments?.map(async (item, index) => {
        const scheduledPayment = item;
        if (Number(scheduledPayment?.payment_amount) >= 10000) {
          return;
        }
        if (Number(scheduledPayment?.payment_amount <= 0)) {
          return;
        }
        const categoryId = tenantCategories?.find(
          (category) => category?.id === Number(scheduledPayment?.category)
        )?.id;
        const paymentAmount = conditionalParse(scheduledPayment?.payment_amount);
        const bankAccountObj = {
          id: scheduledPayment?.id,
          payment_amount: paymentAmount,
          next_occurance: moment(scheduledPayment?.next_occurance).format("YYYY-MM-DD"),
          last_modified: moment().format("YYYY-MM-DD HH:MM:SS"),
          bank_account_id: scheduledPayment?.bank_account_id,
          payment_category: categoryId,
        };
        return await updateRecordTB("PropertyLeasePayment", bankAccountObj);
      });
      const results = await Promise.all(promises);
      if (results?.length > 0) {
        toast.success("Scheduled payments updated successfully");
      } else {
        toast.error("Something went wrong");
      }
      setScheduledPaymentsModalShow(false);
      setEditMode(false);
      setLoading(false);
      getFuturePayments();
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error(error.errorMessage || error.message || "Something went wrong");
    }
  };
  const handleCloseScheduledPaymentsModal = () => {
    setScheduledPaymentsModalShow(false);
    setEditMode(false);
  };

  function currencyMask(rawValue) {
    let numberMask = createNumberMask({
      prefix: "$",
      includeThousandsSeparator: true,
      allowDecimal: true,
      requireDecimal: true,
      allowLeadingZeroes: false,
    });
    let mask = numberMask(rawValue);

    let decimalsRegex = /\.([0-9]{1,2})/;
    let result = decimalsRegex.exec(rawValue);
    // In case there is only one decimal
    if (result && result[1].length < 2) {
      mask.push("0");
    } else if (!result) {
      mask.push("0");
      mask.push("0");
    }

    return mask;
  }

  return (
    <div>
      {loading && (
        <div className="loadingSpinner">
          <SpinnerLoading />
        </div>
      )}

      <div>
        <PDFModal
          show={showPDFModal}
          onHide={handleClosePDF}
          pdfUrl={currentPDFUrl}
          title={`Member Statement Generated on ${moment(formatDate(currentMemberStatement?.created_at))?.format(
            "MMMM Do, YYYY"
          )}`}
        />
        <Modal
          className="modal-style-2"
          show={scheduledPaymentsModalShow}
          onHide={handleCloseScheduledPaymentsModal}
          centered
          size="md"
        >
          <Modal.Header>
            <Modal.Title as="h3" className="w-100 text-center">
              Scheduled Payments
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mb-3 text-center">
            {ScheduledPaymentsFieldArr?.length > 0
              ? "You have scheduled payments. Your monthly rental payments are scheduled for the remainder of your lease according to the payment due date specified in your lease."
              : "There are no scheduled payments at this time. To schedule a payment, select 'Make a Payment'"}

            <div className="table-responsive text-center" data-simplebar style={{ maxHeight: "300px" }}>
              <table className="table document-list">
                <thead>
                  <tr>
                    {!editMode && <th>Payment Type</th>}
                    <th>Date</th>
                    <th>Amount</th>
                    {!editMode && <th>Status</th>}
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {tenantCategories?.length > 0 &&
                    ScheduledPaymentsFieldArr.map((item, index) => {
                      return (
                        <>
                          <tr>
                            {!editMode && (
                              <td>
                                {item?.category}
                                {/*editMode ? (
                                <div className="select" style={{ minWidth: editMode ? 165 : 0 }}>
                                  <select
                                    value={
                                      tenantCategories?.find(
                                        (category) =>
                                          category?.category === watch(`scheduledPayments.${index}.category`)
                                      )?.id
                                    }
                                    onChange={(e) => setValue(`scheduledPayments.${index}.category`, e.target.value)}
                                  >
                                    {tenantCategories.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.category}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )  (
                              )*/}
                              </td>
                            )}
                            <td style={{ minWidth: editMode ? 150 : 0 }}>
                              {editMode && item?.status !== "PENDING" ? (
                                <KeyboardDatePicker
                                  name={`scheduledPayments.${index}.next_occurance`}
                                  onChange={(date) => {
                                    setValue(
                                      `scheduledPayments.${index}.next_occurance`,
                                      moment(date).format("YYYY-MM-DD")
                                    );
                                  }}
                                  value={watch(`scheduledPayments.${index}.next_occurance`)}
                                  className={`form-control ${editMode ? "mt-2" : ""}`}
                                  format="MM/DD/YYYY"
                                  variant="inline" //static
                                  disableToolbar
                                  autoOk
                                  InputAdornmentProps={{ position: "end" }}
                                  keyboardIcon={<img src={CalenderIcon} />}
                                  disablePast
                                  error={false}
                                  helperText={null}
                                />
                              ) : (
                                formatDate(item?.next_occurance)
                              )}
                            </td>
                            <td>
                              {editMode && item?.status !== "PENDING" ? (
                                <MaskedInput
                                  mask={currencyMask}
                                  type="text"
                                  guide={true}
                                  value={watch(`scheduledPayments.${index}.payment_amount`)}
                                  className="form-control"
                                  onChange={(e) => {
                                    const conditions = ["%", "$", "-"];
                                    let value = conditions.some((ie) => e.target.value.includes(ie))
                                      ? e.target.value.includes("$") && e.target.value.includes("-")
                                        ? (e.target.value.split("$")[0] + e.target.value.split("$")[1])?.replace(
                                            /,/g,
                                            ""
                                          )
                                        : e.target.value.includes("$")
                                        ? e.target.value.split("$")[1]?.replace(/,/g, "")
                                        : e.target.value.split("%")[0]
                                      : e.target.value?.replace(/,/g, "");

                                    if (Number(value) >= 10000) {
                                      toast.error("Please enter amount less than 10000");
                                    } else if (Number(value) >= 0) {
                                      setValue(`scheduledPayments.${index}.payment_amount`, e.target.value);
                                    }
                                  }}
                                />
                              ) : (
                                `$${numberWithCommas(item?.payment_amount)}`
                              )}
                            </td>
                            {!editMode && (
                              <td>
                                {item?.status !== "PENDING" ? (
                                  <span
                                    style={{
                                      border: "1px solid #CCCCCC",
                                      color: "#CCCCCC",
                                      padding: "3px 6px",
                                      borderRadius: "15px",
                                    }}
                                  >
                                    {"Scheduled"}
                                  </span>
                                ) : (
                                  <span className="payment-status badge bg-primary">{"Pending"}</span>
                                )}
                              </td>
                            )}
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="container m-0 p-0">
              <Row>
                {ScheduledPaymentsFieldArr?.length > 0 && (
                  <Col xs={6}>
                    <button
                      type="button"
                      className="btn btn-inverse w-100"
                      onClick={() => {
                        setEditMode(!editMode);
                      }}
                    >
                      {editMode ? "Cancel" : "Edit"}
                    </button>
                  </Col>
                )}
                <Col xs={ScheduledPaymentsFieldArr?.length > 0 ? 6 : 12}>
                  <Button
                    className="w-100"
                    onClick={
                      () => {
                        if (editMode) {
                          handleEditScheduledPayments();
                        } else {
                          setScheduledPaymentsModalShow(false);
                        }
                      }
                      //onSavePropertyImagesModal()
                    }
                  >
                    {editMode ? "Save" : "Done"}
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Footer>
        </Modal>
        {/* START page title */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between">
              <div className="page-title">
                <h2>Dashboard</h2>
              </div>
            </div>
          </div>
        </div>
        <PaymentDues
          propertyDetails={propertyDetails}
          propertyDetail={propertyDetail}
          getAllBankAccounts={getAllBankAccounts}
          setLoading={setLoading}
          getBanksTransaction={getBanksTransaction}
          handleViewScheduledPayments={handleViewScheduledPayments}
          allTransactions={allTransactions}
          fetchAllPropertyUnitDocs={fetchAllPropertyUnitDocs}
          deleteDocument={deleteDocument}
          paymentsDue={paymentsDue}
          leases={leases}
          unfilteredLeases={unfilteredLeases}
          isMember={isMember}
          upcomingPayments={upcomingPayments}
          getUpcomingPayments={getFuturePayments}
          propertyPhotos={propertyPhotos}
          tenantLedger={tenantLedger}
          getTenantLedger={getTenantLedger}
          payabliLoading={payabliLoading}
          tenantWidgets={tenantWidgets}
        />
        <Row>
          {/*
          <Col xl={7} lg={12} md={12} className="block d-none d-lg-block card p-4">
            <div className="card-body">
              <div className="p-0">
                <div className="d-flex align-items-center mb-3">
                  <div className="flex-grow-1">
                    <h4 className="card-title">Your Documents List</h4>
                  </div>
                </div>
                <div>
                  <DocumentList deleteDocument={deleteDocument} />
                  <div className="uploadDocuments">
                    <MyDropzone
                      propertyDetail={
                        leases?.find((lease) => checkIfWithin(lease)) || (leases?.length > 0 ? leases[0] : null)
                      }
                      setLoading={setLoading}
                      fetchAllPropertyUnitDocs={fetchAllPropertyUnitDocs}
                      text="+ Upload Documents"
                      removeBorder={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
                    */}
        </Row>
        {/* START Mobile View */}
        <div className="dashboard-mob-view d-lg-none">
          <div className="accordion accordion-v1" id="accordionExample">
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  <span className="title">Lease Summary</span>
                </button>
              </h3>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <LeaseSummary
                    propertyDetail={propertyDetail}
                    leases={leases}
                    unfilteredLeases={unfilteredLeases}
                    isMember={isMember}
                  />
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  <span className="title">{isMember ? "Site Manager" : "Property Manager"}</span>
                </button>
              </h3>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <PropertyManager />
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  <span className="title">Your Address</span>
                </button>
              </h3>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <Address propertyDetail={propertyDetail} propertyPhotos={propertyPhotos} />
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  <span className="title">Your Document List</span>
                </button>
              </h3>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <DocumentList deleteDocument={deleteDocument} />
                  <div className="uploadDocuments">
                    <MyDropzone
                      propertyDetail={
                        leases?.find((lease) => checkIfWithin(lease)) || (leases?.length > 0 ? leases[0] : null)
                      }
                      setLoading={setLoading}
                      fetchAllPropertyUnitDocs={fetchAllPropertyUnitDocs}
                      text="+ Upload Documents"
                      removeBorder={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/*
            <div className="accordion-item">
              <h3 className="accordion-header" id="headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  <span className="title">Payment History</span>
                </button>
              </h3>
              <div
                id="collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <PaymentHistory allTransactions={allTransactions} tenantCategories={tenantCategories} />
                </div>
              </div>
            </div>
            */}
          </div>
          <div className="file mb-4 mb-xl-0">
            <div className="uploadDocuments">
              <button
                className="btn btn-inverse w-100"
                style={{ color: "#1a5e61" }}
                onClick={() => navigate("/Maintenance")}
              >
                Submit Maintenance Request{" "}
                <img className="mx-2" src={require("../../assets/images/maintenance-green.svg").default} alt="" />
              </button>
            </div>
          </div>
          {/* end upload file button */}
        </div>
        {/* END Mobile View */}
      </div>
    </div>
  );
};

export default Dashboard;
